import { Phone, Mail, Linkedin} from "lucide-react";
import { Link } from 'react-router-dom';
import profilePhoto from '../assets/self.webp';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/art-portfolio', label: 'Art Portfolio' },
    { path: '/cs-portfolio', label: 'CS Portfolio' }
  ];

  const socialLinks = [
    {
      href: "tel:8016366104",
      icon: Phone,
      label: "Phone",
      ariaLabel: "Call Catherine"
    },
    {
      href: "mailto:catherine.1bao@gmail.com",
      icon: Mail,
      label: "Email",
      ariaLabel: "Email Catherine"
    },
    {
      href: "https://www.linkedin.com/in/catherineba0/",
      icon: Linkedin,
      label: "LinkedIn",
      ariaLabel: "Catherine's LinkedIn profile",
      external: true
    }
  ];

  return (
    // `snap-end` rather than `snap-start`: the footer is shorter than a viewport, so
    // its top edge sits past the document's maximum scroll and a start-aligned stop
    // would be unreachable — which under mandatory snapping would strand the footer
    // off-screen entirely. Aligning its end lands exactly on the document end.
    <footer className="bg-black border-t border-red-500 text-[#F7DB00] snap-end">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          <div className="flex items-center gap-4">
            <img
              src={profilePhoto}
              alt="Catherine Bao"
              className="w-16 h-16 rounded-full object-cover border border-red-500 flex-shrink-0"
            />
            <h3 className="text-3xl font-bold text-[#F7DB00]">
              <span style={{ fontFamily: '"Zaslia", serif' }}>Catherine </span>
              <span className="font-normal" style={{ fontFamily: '"Priestacy", cursive' }}>bao</span>
            </h3>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-[#F7DB00] mb-3">Navigate</h4>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-[#F7DB00] hover:text-[#FFEB5C] transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
               <li>
                 <a
                   href="/CV_catherinebao.pdf"
                   target="_blank"
                   rel="noopener noreferrer"
                   className="text-[#F7DB00] hover:text-[#FFEB5C] transition-colors text-sm"
                 >
                   Download CV
                 </a>
               </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold text-[#F7DB00] mb-3">Connect</h4>
            <div className="flex gap-4 mb-4">
              {socialLinks.map((link) => {
                const IconComponent = link.icon;
                const linkProps = link.external 
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {};
                
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    className="text-[#F7DB00] hover:text-[#FFEB5C] transition-colors"
                    aria-label={link.ariaLabel}
                    {...linkProps}
                  >
                    <IconComponent className="w-6 h-6" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        <div className="border-t border-red-900 pt-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-[#F7DB00] mb-2 sm:mb-0">
            © {currentYear} Catherine Bao. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
